<template>
  <v-btn :style="styleObject" :rounded="rounded" @click="link != '' || link != null ? changeurl(link) : null" class="mr-2"
    data-toggle="tooltip" :small="small" :title="dataTitleTooltip">
    <span for="" v-if="name == 'edit'" style="display: contents;">
      <b-icon icon="pencil-square" font-scale="1.5" style="color: white; margin-right: 5px;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'settings'" style="display: contents;">
      <b-icon icon="gear-fill" font-scale="1.5" style="color: white; margin-right: 5px;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'search'" style="display: contents;">
      <b-icon icon="search" font-scale="1.5" style="color: white; margin-right: 5px;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'tambah'" style="display: contents;">
      <b-icon icon="plus-circle" font-scale="1.5" style="color: white; margin-right: 5px;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'view'" style="display: contents;">
      <b-icon icon="eye" font-scale="1.5" style="color: white; margin-right: 5px;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'absen'" style="display: contents;">
      <b-icon icon="chevron-right" font-scale="1.5" style="color: #3751E4;  font-size: 120%;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'tambah_angkatan'" style="display: contents; color: #3751E4;">
      <b-icon icon="plus-circle" font-scale="1.5" style="color: #3751E4; margin-right: 5px;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'tambah_nilai_akademik'" variant="outline-primary"
      style="display: contents; color: #ffffff;">
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'generate'" style="display: contents;">
      <b-icon icon="arrow-repeat" font-scale="1.5" style="color: #ffffff; margin-right: 2px;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'aspek_jasmani'" style="display: contents; color: #ffffff;">
      <b-icon icon="plus-circle" font-scale="1.5" style="color: #ffffff; margin-right: 2px;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'eye'" style="display: contents;">
      <i class="fa fa-eye" style="color: white; margin-right: 5px;"></i>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'eye-schedule'" style="display: contents;">
      <i class="fa fa-eye" style="color: #3751E4;"></i>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'camera-profil'" style="display: contents; color:#3751E4; ">
      <i class="fa fa-camera" style="color: #3751E4; margin-right: 5px;"></i>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'qr'" style="display: contents;">
      <i class="fa fa-qrcode" font-scale="1.5" style="color:white; margin-right: 5px;">
        {{ this.Title }}
      </i>
    </span>
    <span for="" v-else-if="name == 'hapus'" style="display: contents;">
      <i class="fa fa-trash" font-scale="1.5" style="color: white; margin-right: 5px;"></i>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'check_krs'" style="display: contents;">
      <i class="fa fa-check-square" font-scale="1.5" style="color: white; margin-right: 5px;"></i>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'print'" style="display: contents;">
      <b-icon icon="download" font-scale="1.5" style="color: white; margin-right: 5px;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'lock'" style="display: contents;">
      <b-icon icon="lock" font-scale="1.5" style="color: white; margin-right: 5px;"></b-icon>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'csv'" style="display: contents">
      <i class="fas fa-file-csv" font-scale="1.5" style="color:white; margin-right: 5px"></i>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'detail'" style="display: contents">
      {{ this.Title }}
    </span>

    <span for="" v-else-if="name == 'generate-nilai'" style="display: contents">
      <b-icon icon="gear-fill" font-scale="1.5" style="color: white; margin-right: 5px;"></b-icon>
      {{ this.Title }}
    </span>

    <span for="" v-else-if="name == 'status-mhs'" style="display: contents">
      <i class="fas fa-info" font-scale="1.5" style="color:white;"></i>
      {{ this.Title }}
    </span>

    <span for="" v-else-if="name == 'kelompok'" style="display: contents">
      <i class="fas fa-user-friends" font-scale="1.5" style="color:white;"></i>
      {{ this.Title }}
    </span>

    <span for="" v-else-if="name == 'kelompok-tmbh'" style="display: contents">
      <i class="fas fa-user-plus" font-scale="1.5" style="color:white;"></i>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'print-p'" style="display: contents">
      <i class="fas fa-print" font-scale="1.5" style="color:white;"></i>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'presence'" style="display: contents">
      <i class="fas fa-file-alt" font-scale="1.5" style="color:white;"></i>
      {{ this.Title }}
    </span>
    <span for="" v-else-if="name == 'tanpaicon'" style="display: contents">
      {{ this.Title }}
    </span>
    
    <span font-scale="1.5" style="display: contents;" v-else> <i :class="customico"
        style="color: white; margin-right: 5px;" v-if="customico.includes('fa')"></i> <b-icon :icon="customico"
        font-scale="1.5" style="color: white; margin-right: 5px;" class="mr-2" v-else></b-icon> {{ name != '' ? this.name
          : this.Title }}</span>
  </v-btn>
</template>

<script>
export default {
  props: {
    colors: {
      type: String,
      default: () => "#17A1FA",
    },
    name: String,
    small: {
      type: Boolean,
      default: () => false,
    },
    link: String,
    customico: String,
    Title: String,
    dataTitleTooltip: String,
    rounded: { 
      type: Boolean,
      default: () => false
    }
  },
  name: 'buttonComponent',
  data() {
    return {
      styleObject: {
        backgroundColor: this.$props.colors,
        color: 'white',
        // zIndex: 1,
        /*
          Note Himawan: zIndex diubah menjadi 0, karena jika zIndex 1, tombol edit, hapus, dll bisa overlap di depan footer
        */
        // height: '30px',
        // width: '30px',
        // minWidth: '30px',
      }
    }
  },
  methods: {
    changeurl(params) {
      this.$router.push({ path: params }).catch(() => { });
    }
  },
}
</script>